import api from '../../../api/api'

export default {
  fieldList: async reportType => {
    const result = await api.get.reportFieldList(reportType)

    return result
  },

  extractList: async (reportType, projectId) => {
    const result = await api.get.reportExtractList(reportType, projectId)

    return result
  },

  extractSave: async form => {
    const result = await api.save.reportSaveExtract(form)

    return result
  },

  extractDelete: async id => {
    const result = await api.delete.reportExtractDelete(id)

    return result
  },

  extract: async form => {
    const result = await api.save.reportExtract(form)

    return result
  },
}
